import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { JPYs, ProcessDetailGroups, secondsToHms } from '../common/Common';
import { useEffect, useState } from 'react';
import { MaterialSurfaceBillingUnit, ProcessDetailGroup, WorkType } from '../common/enums';
import { BlankTypes } from '../common/Constant';
import { add } from 'lodash';

const IQ3KouteiBetsuKesanshiki_Hyoumen = (props) => {
  const [hyoumenProcessInput, setHyoumenProcessInput] = useState([]);

  const [sagyoAmt, setSagyoAmt] = useState(0);
  const [sagyoTime, setSagyoTime] = useState(0);
  const [mWorkHRate, setmWorkHRate] = useState(0);

  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  const isDetailOpen = openInputSubDetailKeys.has('kakou-detail-open');

  const additions = props?.hyoumenData?.additions?.filter((item) => item.processId == props?.processMst?.id)[0];

  const processName = props?.hyoumenData?.additions?.filter((item) => item.processId == props?.processMst?.id)[0]
    .dataItems?.[0].processName;

  const calMethod = props?.hyoumenData?.additions?.filter((item) => item.processId == props?.processMst?.id)[0]
    .dataItems?.[0].calMethod;

  const calInput = props?.hyoumenData?.additions?.filter((item) => item.processId == props?.processMst?.id)[0]
    .dataItems?.[0].calInput;

  const processType = parseInt(
    props?.hyoumenData?.additions?.filter((item) => item.processId == props?.processMst?.id)[0].dataItems?.[0]
      .processDetailTypeNo
  );

  const groupType = parseInt(
    props?.hyoumenData?.additions?.filter((item) => item.processId == props?.processMst?.id)[0].dataItems?.[0]
      .processDetailWorkTypeGroup
  );

  const typeName = props?.processMst?.details?.processDetailTypes?.find((t) => t.id == processType)?.name || '不明';

  const groupName = ProcessDetailGroups?.filter((item) => item.value == groupType)[0].label;

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.estimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.hyoumenData?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  const productionQuantityCoeff = getProductionQuantityCoeff(props?.deviceMst);

  useEffect(() => {
    let hyoumenProcessInput = props?.hyoumenData?.processInput?.filter(
      (item) => item.processId == props?.processMst?.id
    )[0];
    if (hyoumenProcessInput) {
      setHyoumenProcessInput(hyoumenProcessInput);
    }

    calculateHyoumen();
  }, [props?.hyoumenData]);

  const calculateHyoumen = () => {
    let detailProcessInput = props?.hyoumenData?.processInput?.filter(
      (item) => item.processId == props?.processMst?.id
    )[0]?.details?.[0];
    let calInput =
      detailProcessInput?.calcType == MaterialSurfaceBillingUnit.SquareMeter ||
      detailProcessInput?.calcType == MaterialSurfaceBillingUnit.Work
        ? detailProcessInput?.areaUnitPrice
        : detailProcessInput?.weightUnitPrice;
    calInput = Number(calInput) || 0;
    // 加工時間設定（加工時間	＊	重量係数）
    let sagyoTime = 0;
    let mWorkHRate = 0;
    let sagyoAmt = 0;

    let shoriDetail = ProcessDetailGroup.DoubleSide == additions?.dataItems[0]?.processDetailWorkTypeGroup ? 2 : 1;

    if (calMethod == '時間') {
      sagyoAmt = calSagyoAmt(sagyoTime, props?.deviceMst, calMethod, shoriDetail, processType);
    } else if (calMethod == '面積') {
      calInput = calInput / 10000;
      calInput = Number.isFinite(calInput) ? calInput : 0;
      mWorkHRate = props?.deviceMst?.details?.charges[processType]?.squareMeter;
      // sagyoAmt = calInput * mWorkHRate * shoriDetail; //部品矩形面積 *チャージ金額(A) // 両面塗装の場合は片面塗装*2
    } else if (calMethod == '重量') {
      mWorkHRate = props?.deviceMst?.details?.charges[processType]?.weight;
      sagyoAmt = calInput * mWorkHRate * shoriDetail; //重量＊重量チャージ
    }
    setmWorkHRate(mWorkHRate);

    setSagyoTime(sagyoTime);
    setSagyoAmt(sagyoAmt);
  };

  const calSagyoAmt = (cSagyoTimeSec, deviceMst, calMethod, shoriDetail, processType) => {
    //装置の作業時間チャージ
    let mWorkHRate = 0;
    if (calMethod == '面積') {
      mWorkHRate = deviceMst?.details?.charges[processType]?.squareMeter;
    } else if (calMethod == '時間') {
      mWorkHRate = deviceMst?.details?.charges[processType]?.work;
    }
    // // 作業時間
    // let mWorkHTime = cSagyoTimeSec;
    // let mWorkHTimeMin = mWorkHTime / 60;
    // //　加工時間＊時間チャージ
    // let cSagyoAmt = (mWorkHTimeMin * mWorkHRate) / 60.0;
    let cSagyoAmt = mWorkHRate;
    cSagyoAmt = Number.isFinite(cSagyoAmt) ? cSagyoAmt * shoriDetail : 0;
    return cSagyoAmt;
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };
  const toggleInputSubDetail = (parentKey, index) => {
    const key = `${parentKey}-${index}`;
    setOpenInputSubDetailKeys((prevKeys) => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key);
      } else {
        newKeys.add(key);
      }
      return newKeys;
    });
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => kakouOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isKakouOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>
      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'open')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{processName}</label>
          </Col>
        </Row>
      </div>

      {isDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'作業時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'作業金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'計算法/入力'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'処理選択'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'加工時間 x 重量係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'作業時間(秒) x 作業時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{calMethod}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{groupName}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${sagyoTime} x ${productionQuantityCoeff} = ${sagyoTime} (${secondsToHms(
                    sagyoTime
                  )})`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${sagyoTime} × ${mWorkHRate} = ${JPYs.format(Math.round(sagyoAmt))}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${calInput}`}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{`${typeName}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_Hyoumen;
